import { Rabbit, PawPrint, Bot, Cat, Bird, Turtle, Sparkles, Rocket } from "lucide-react";

export const AVATAR_MAP = {
  fox: { Icon: Rabbit, color: "#F97316", label: "Foxy" },
  panda: { Icon: PawPrint, color: "#0F172A", label: "Panda" },
  robot: { Icon: Bot, color: "#3B82F6", label: "Robo" },
  cat: { Icon: Cat, color: "#EC4899", label: "Kitty" },
  owl: { Icon: Bird, color: "#8B5CF6", label: "Owly" },
  dino: { Icon: Turtle, color: "#10B981", label: "Dino" },
  unicorn: { Icon: Sparkles, color: "#F43F5E", label: "Sparkle" },
  astronaut: { Icon: Rocket, color: "#0EA5E9", label: "Astro" },
};

export const AVATAR_KEYS = Object.keys(AVATAR_MAP);

// `img` (a generated avatar URL) takes precedence over the lucide-icon avatars.
export default function Avatar({ avatar = "fox", img = null, size = 56, testId }) {
  if (img) {
    return (
      <img
        src={img}
        alt=""
        data-testid={testId}
        className="rounded-full border-4 border-slate-900 shrink-0 object-cover bg-white"
        style={{ width: size, height: size, boxShadow: "3px 3px 0 0 #0F172A" }}
      />
    );
  }
  const conf = AVATAR_MAP[avatar] || AVATAR_MAP.fox;
  const { Icon, color } = conf;
  return (
    <div
      data-testid={testId}
      className="flex items-center justify-center rounded-full border-4 border-slate-900 shrink-0"
      style={{
        width: size,
        height: size,
        background: color,
        boxShadow: "3px 3px 0 0 #0F172A",
      }}
    >
      <Icon color="#fff" size={size * 0.5} strokeWidth={2.5} />
    </div>
  );
}
